import { ConnectionStates, avSelectors, useAvContext } from "@minervaproject/avsubsystem";
import { useEffect } from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { useUserProperties } from "hooks/use_user_properties";
import { localSelectors } from "store";

function FatalErrorObserver() {
  const avConnection = useAvContext();
  const userId = useAppSelector(localSelectors.selectCurrentUserId());

  const user = useUserProperties(userId, ["is_performing_av_check", "is_recording_agent"]);
  // We could have other types of fatal errors here
  const isConnectionFatalAlert = avSelectors.useConnectionState() === ConnectionStates.fatalError;
  const message = "Failed connecting to the video server. Press ok to refresh the page.";

  useEffect(() => {
    if (!avConnection || user?.is_performing_av_check || !isConnectionFatalAlert) return;
    if (user?.is_recording_agent) {
      document.location.reload();
    } else {
      alert(message);
      document.location.reload();
    }
  }, [avConnection, isConnectionFatalAlert, user]);

  return null;
}

export { FatalErrorObserver };
